import { useEffect, useState } from 'react'

export type WebGLSupport = 'checking' | 'supported' | 'unsupported'

let cached: WebGLSupport | null = null

export const detectWebGL = (): WebGLSupport => {
    if (cached) return cached

    try {
        const canvas = document.createElement('canvas')
        const context = canvas.getContext('webgl2') || canvas.getContext('webgl')

        cached = context ? 'supported' : 'unsupported'

        /* release the probe context so it never counts against the browser's limit */
        context?.getExtension('WEBGL_lose_context')?.loseContext()
    }
    catch {
        cached = 'unsupported'
    }

    return cached
}

export const useWebGLSupport = (): WebGLSupport => {
    const [support, setSupport] = useState<WebGLSupport>('checking')

    useEffect(() => {
        setSupport(detectWebGL())
    }, [])

    return support
}
